// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  margin-left: var(--sidebar-width);
  transition: all 0.3s ease;
  min-width: 0;
}

.main-content.sidebar-closed {
  margin-left: 0;
}

.main-content.sidebar-collapsed {
  margin-left: 70px;
}

.content-container {
  padding: 30px;
  min-height: calc(100vh - var(--header-height));
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOutRight {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(400px);
    opacity: 0;
  }
}

/* Notification */
.notification {
  position: fixed;
  top: 90px;
  right: 30px;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 10000;
  animation: slideInRight 0.3s ease;
  color: white;
}

.notification.success {
  background: var(--success-color);
}

.notification.error {
  background: var(--danger-color);
}

.notification.info {
  background: var(--info-color);
}

.notification.warning {
  background: var(--warning-color);
}

/* Responsive */
@media (max-width: 1024px) {
  .main-content {
    margin-left: 0;
  }
  
  .content-container {
    padding: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".app {\n  display: flex;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  margin-left: var(--sidebar-width);\n  transition: all 0.3s ease;\n  min-width: 0;\n}\n\n.main-content.sidebar-closed {\n  margin-left: 0;\n}\n\n.main-content.sidebar-collapsed {\n  margin-left: 70px;\n}\n\n.content-container {\n  padding: 30px;\n  min-height: calc(100vh - var(--header-height));\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideOutRight {\n  from {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  to {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n}\n\n/* Notification */\n.notification {\n  position: fixed;\n  top: 90px;\n  right: 30px;\n  padding: 15px 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  z-index: 10000;\n  animation: slideInRight 0.3s ease;\n  color: white;\n}\n\n.notification.success {\n  background: var(--success-color);\n}\n\n.notification.error {\n  background: var(--danger-color);\n}\n\n.notification.info {\n  background: var(--info-color);\n}\n\n.notification.warning {\n  background: var(--warning-color);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .main-content {\n    margin-left: 0;\n  }\n  \n  .content-container {\n    padding: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
